const sizeMap = {
	small: "h-8 w-8",
	medium: "h-16 w-16",
	large: "h-32 w-32",
};

const LoadingSpinner = ({
	containerHeight = "h-64", // <- Par défaut, hauteur du conteneur
	size = "medium", // small | medium | large
	borderColor = "border-gray-700", // Couleur de la bordure
}) => {
	const spinnerSize = sizeMap[size] || sizeMap["medium"];

	return (
		<div className={`flex items-center justify-center ${containerHeight} w-64`}>
			<div
				className={`animate-spin rounded-full border-t-2 border-b-2 ${spinnerSize} ${borderColor}`}
			></div>
		</div>
	);
};

export default LoadingSpinner;
